import { useEffect } from 'react';
import { Platform } from 'react-native';
import { useAppSelector } from '../redux/helper';
import {
  selectActivationHighlightedTask,
  selectActivationTrackerPhase,
} from '../redux/ownerActivationSlice';
import { syncGettingStartedNotification } from '../utils/gettingStartedNotification';

/**
 * Keeps the daily 10am Getting Started local nudge in sync with the current
 * highlighted location-scoped activation task (excludes visit_test_location).
 *
 * Waits for the one-time legacy trigger sweep so cancelAll cannot wipe a
 * freshly scheduled Getting Started notification on first post-upgrade launch.
 */
export const useGettingStartedNotificationSchedule = (args: {
  isLoggedIn: boolean;
  legacyTriggersCleared: boolean;
}) => {
  const { isLoggedIn, legacyTriggersCleared } = args;
  const phase = useAppSelector(selectActivationTrackerPhase);
  const highlightedTaskId = useAppSelector(selectActivationHighlightedTask);

  useEffect(() => {
    if (Platform.OS === 'web') return;
    if (!legacyTriggersCleared) return;

    let cancelled = false;
    void (async () => {
      const target = await syncGettingStartedNotification({
        isLoggedIn,
        phase,
        highlightedTaskId,
      });
      if (!cancelled && target) {
        console.log('Scheduled Getting Started notification for:', target);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [highlightedTaskId, isLoggedIn, legacyTriggersCleared, phase]);
};
